import React from 'react'
import './App.css'
import Home from './components/Home'

function parseUrl(input) {
  const [url, qs = ''] = String(input).split('?')
  return { url, query: Object.fromEntries(new URLSearchParams(qs)) }
}

class App extends React.Component {
  render() {
    sessionStorage.clear()

    const params = parseUrl(window.location.href)

    try {
      const uri = atob(params.query.edp)
      const paramuri = parseUrl(uri)
      const index = paramuri.url.indexOf('checkin')
      const pathArray = paramuri.url.substring(0, index)

      sessionStorage.setItem('url', pathArray)
      sessionStorage.setItem('bookingId', paramuri.query.bookingId)
      sessionStorage.setItem('propertyId', paramuri.query.propertyId)

      return <Home propertyId={true} bookingId={true} loading={true} />
    } catch (ex) {
      return <Home propertyId={false} bookingId={false} loading={false} />
    }
  }
}

export default App
